/**
 * Created by SunZhuang on 2019/1/21.
 */
import React from 'react';
import './index.scss';

const Loading = ({ }) => {
  return (
    <div className='body'>
      <div className='loadingbox'>
        <div className='bac' />
        <div className='loading'>
          <span />
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default Loading;
